import SalesRecordingContainer from './sales-recording-container';

export default SalesRecordingContainer;
